import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-12 md:p-16 text-center">
      <title>页面未找到 - 甜蜜惩罚动漫</title>
      <p className="font-heading text-6xl md:text-8xl text-primary-200 select-none">404</p>
      <h1 className="font-heading text-xl md:text-2xl text-foreground-950 mt-4 mb-3">这个页面还没有内容</h1>
      <p className="text-sm text-foreground-500 font-label mb-6 max-w-md mx-auto leading-relaxed">
        你访问的地址可能已经调整或输入有误。回到首页，或从全集剧情重新开始浏览吧。
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-5-line"></i> 返回首页
        </Link>
        <Link
          to="/episodes"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm font-label hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-film-line"></i> 浏览全集剧情
        </Link>
      </div>
    </div>
  );
}